import {Habilitation} from '../habilitation/habilitation';

export class Authentication {
    email: string;
    habilitation: Habilitation;
    chercheurEtranger: boolean;
}
